const selectors = {
  scrollToTopButton: "button.scroll-to-top",
  jumpLinksContainer: "div.jump-links-container",
  mobileJumpLinksContainer: "div.mobile-jump-links-container",
  subnavigationContainer: "sub-navigation",
};

export default selectors;
